module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overflow-x-hidden"
  }, [_c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "150px",
      "margin-top": "50px"
    }
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n        GO BACK\n      ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "w-3/4 mx-52 mb-14"
  }, [_c('div', {
    staticClass: "welcome-online-rts mt4"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row mt3"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "tab-title"
  }, [_vm._v(" Teachers ")]), _vm._v(" "), _c('toggle-button', {
    staticClass: "ml2",
    attrs: {
      "sync": true,
      "labels": true,
      "color": "#72ccd7"
    },
    model: {
      value: (_vm.ort_teachers_settings.enabled),
      callback: function($$v) {
        _vm.$set(_vm.ort_teachers_settings, "enabled", $$v)
      },
      expression: "ort_teachers_settings.enabled"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt3"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('pl-input', {
    attrs: {
      "placeholder": "YouTube Video"
    },
    model: {
      value: (_vm.ort_teachers_settings.video_url),
      callback: function($$v) {
        _vm.$set(_vm.ort_teachers_settings, "video_url", $$v)
      },
      expression: "ort_teachers_settings.video_url"
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.ort_teachers_settings.links), function(link, index) {
    return _c('div', {
      key: index,
      staticClass: "row mt1"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('pl-input', {
      class: [_vm.invalidName(link) ? 'invalidField' : ''],
      attrs: {
        "placeholder": 'Link ' + _vm.getPostion(index) + ' Name'
      },
      model: {
        value: (link.name),
        callback: function($$v) {
          _vm.$set(link, "name", $$v)
        },
        expression: "link.name"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('pl-input', {
      class: [_vm.invalidURL(link) ? 'invalidField' : ''],
      attrs: {
        "placeholder": 'Link ' + _vm.getPostion(index) + ' URL'
      },
      model: {
        value: (link.url),
        callback: function($$v) {
          _vm.$set(link, "url", $$v)
        },
        expression: "link.url"
      }
    })], 1)])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "tab-title"
  }, [_vm._v(" Students ")]), _vm._v(" "), _c('toggle-button', {
    staticClass: "ml2",
    attrs: {
      "sync": true,
      "labels": true,
      "color": "#72ccd7"
    },
    model: {
      value: (_vm.ort_students_settings.enabled),
      callback: function($$v) {
        _vm.$set(_vm.ort_students_settings, "enabled", $$v)
      },
      expression: "ort_students_settings.enabled"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt3"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('pl-input', {
    attrs: {
      "placeholder": "YouTube Video"
    },
    model: {
      value: (_vm.ort_students_settings.video_url),
      callback: function($$v) {
        _vm.$set(_vm.ort_students_settings, "video_url", $$v)
      },
      expression: "ort_students_settings.video_url"
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.ort_students_settings.links), function(link, index) {
    return _c('div', {
      key: index,
      staticClass: "row mt1"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('pl-input', {
      class: [_vm.invalidName(link) ? 'invalidField' : ''],
      attrs: {
        "placeholder": 'Link ' + _vm.getPostion(index) + ' Name'
      },
      model: {
        value: (link.name),
        callback: function($$v) {
          _vm.$set(link, "name", $$v)
        },
        expression: "link.name"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('pl-input', {
      class: [_vm.invalidURL(link) ? 'invalidField' : ''],
      attrs: {
        "placeholder": 'Link ' + _vm.getPostion(index) + ' URL'
      },
      model: {
        value: (link.url),
        callback: function($$v) {
          _vm.$set(link, "url", $$v)
        },
        expression: "link.url"
      }
    })], 1)])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "welcome-live-rts mt4"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row mt3"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "tab-title"
  }, [_vm._v(" Teachers ")]), _vm._v(" "), _c('toggle-button', {
    staticClass: "ml2",
    attrs: {
      "sync": true,
      "labels": true,
      "color": "#72ccd7"
    },
    model: {
      value: (_vm.lrt_teachers_settings.enabled),
      callback: function($$v) {
        _vm.$set(_vm.lrt_teachers_settings, "enabled", $$v)
      },
      expression: "lrt_teachers_settings.enabled"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt3"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('pl-input', {
    attrs: {
      "placeholder": "YouTube Video"
    },
    model: {
      value: (_vm.lrt_teachers_settings.video_url),
      callback: function($$v) {
        _vm.$set(_vm.lrt_teachers_settings, "video_url", $$v)
      },
      expression: "lrt_teachers_settings.video_url"
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.lrt_teachers_settings.links), function(link, index) {
    return _c('div', {
      key: index,
      staticClass: "row mt1"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('pl-input', {
      class: [_vm.invalidName(link) ? 'invalidField' : ''],
      attrs: {
        "placeholder": 'Link ' + _vm.getPostion(index) + ' Name'
      },
      model: {
        value: (link.name),
        callback: function($$v) {
          _vm.$set(link, "name", $$v)
        },
        expression: "link.name"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('pl-input', {
      class: [_vm.invalidURL(link) ? 'invalidField' : ''],
      attrs: {
        "placeholder": 'Link ' + _vm.getPostion(index) + ' URL'
      },
      model: {
        value: (link.url),
        callback: function($$v) {
          _vm.$set(link, "url", $$v)
        },
        expression: "link.url"
      }
    })], 1)])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "tab-title"
  }, [_vm._v(" Students ")]), _vm._v(" "), _c('toggle-button', {
    staticClass: "ml2",
    attrs: {
      "sync": true,
      "labels": true,
      "color": "#72ccd7"
    },
    model: {
      value: (_vm.lrt_students_settings.enabled),
      callback: function($$v) {
        _vm.$set(_vm.lrt_students_settings, "enabled", $$v)
      },
      expression: "lrt_students_settings.enabled"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt3"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('pl-input', {
    attrs: {
      "placeholder": "YouTube Video"
    },
    model: {
      value: (_vm.lrt_students_settings.video_url),
      callback: function($$v) {
        _vm.$set(_vm.lrt_students_settings, "video_url", $$v)
      },
      expression: "lrt_students_settings.video_url"
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.lrt_students_settings.links), function(link, index) {
    return _c('div', {
      key: index,
      staticClass: "row mt1"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('pl-input', {
      class: [_vm.invalidName(link) ? 'invalidField' : ''],
      attrs: {
        "placeholder": 'Link ' + _vm.getPostion(index) + ' Name'
      },
      model: {
        value: (link.name),
        callback: function($$v) {
          _vm.$set(link, "name", $$v)
        },
        expression: "link.name"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('pl-input', {
      class: [_vm.invalidURL(link) ? 'invalidField' : ''],
      attrs: {
        "placeholder": 'Link ' + _vm.getPostion(index) + ' URL'
      },
      model: {
        value: (link.url),
        callback: function($$v) {
          _vm.$set(link, "url", $$v)
        },
        expression: "link.url"
      }
    })], 1)])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "welcome-online-rts mt4"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row mt3"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row mt3"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('pl-input', {
    attrs: {
      "placeholder": "YouTube Video"
    },
    model: {
      value: (_vm.sample_written_settings.video_url),
      callback: function($$v) {
        _vm.$set(_vm.sample_written_settings, "video_url", $$v)
      },
      expression: "sample_written_settings.video_url"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row mt3"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('pl-input', {
    attrs: {
      "placeholder": "YouTube Video"
    },
    model: {
      value: (_vm.sample_verbal_settings.video_url),
      callback: function($$v) {
        _vm.$set(_vm.sample_verbal_settings, "video_url", $$v)
      },
      expression: "sample_verbal_settings.video_url"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "centered-div mt4"
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.saveChanges.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        Save Changes\n      ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v(" Written RoundTable ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Verbal RoundTable ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Sample RoundTables")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "tab-title"
  }, [_vm._v("Written RoundTable")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "tab-title"
  }, [_vm._v(" Verbal RoundTable ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-6af8955f!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminWelcomeModals.vue
// module id = 1939
// module chunks = 61